<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import AppLayout from '@/Layouts/AppLayout.vue';

const props = defineProps({
    email: String,
    token: String,
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <AppLayout title="Reset Password Inspire Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Reset Password
            </h2>
        </template>

        <JetAuthenticationCard>
            <template #logo>
                <JetAuthenticationCardLogo />
            </template>

            <JetValidationErrors class="mb-4" />

            <form @submit.prevent="submit">
                <div>
                    <JetLabel for="email" value="Email" />
                    <JetInput
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="mt-1 block w-full"
                        required
                        autofocus
                    />
                </div>

                <div class="mt-4">
                    <JetLabel for="password" value="New Password" />
                    <JetInput
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="mt-1 block w-full"
                        required
                        autocomplete="new-password"
                    />
                </div>

                <div class="mt-4">
                    <JetLabel for="password_confirmation" value="Confirm New Password" />
                    <JetInput
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        class="mt-1 block w-full"
                        required
                        autocomplete="new-password"
                    />
                </div>

                <div class="flex items-center justify-end mt-4">
                    <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Reset Password
                    </JetButton>
                </div>
            </form>
        </JetAuthenticationCard>
    </AppLayout>
</template>
